import React, { useContext } from "react";
import _ from "lodash";
import { useLocation, Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../../context/authContext";
import { isAuthed, isCompanyAdmin } from "../../utils/authorization";
import AuthRedirect from "./AuthRedirect";
import { Error } from "../../views";

const RequireAuth = ({ roleAccess }) => {
  const { auth } = useAuth();
  const location = useLocation();
  const authenticated = !_.isNil(auth);

  if (!authenticated) {
    return <Navigate to="/signin" state={{ from: location }} replace />;
  }

  const subReqPassed = auth.isSubscribed || auth.hasSubscriptionBypass;
  const needOnboard = isCompanyAdmin(auth) && (!auth.isVerified || !auth.organization || !subReqPassed);

  if (needOnboard) {
    return <Navigate to="/onboard" state={{ from: location }} replace />;
  } else if (!isAuthed(auth, "vantage facilitator") && !subReqPassed) {
    // if they are department admins or lower and they are not subscribed
    return <Error title="Unauthorized" body="Invalid subscription, please contact admin" />;
  }

  if (!isAuthed(auth, roleAccess)) {
    return <AuthRedirect />;
  }

  return <Outlet />;
};

export default RequireAuth;
